import { useSearch } from "@tanstack/react-router";
import { useGetIntegrationQuery } from "api/TenantSlug/Integration/hooks";
import { ModifyIntegrationMethodsForm } from "components/Forms/ModifyIntegrationMethodsForm/ModifyIntegrationMethodsForm";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle.tsx";
import { useDrawer } from "hooks/useDrawer";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId } from "types/models.ts";

interface SearchParams {
    [`modifyIntegrationMethods-id`]: string;
}

export const ModifyIntegrationMethodsDrawer: FC = () => {
    const { t } = usePaldockTranslation("drawers.modify-integration-methods");
    const drawerId = DrawerId.ModifyIntegrationMethods;
    const drawerUtils = useDrawer();

    const searchParams = useSearch({ strict: false }) as SearchParams;
    const integrationId = searchParams[`${drawerId}-id`];
    const getIntegrationQuery = useGetIntegrationQuery(integrationId);

    if (getIntegrationQuery.isLoading || getIntegrationQuery.isFetching || !getIntegrationQuery.data?.integration) {
        return <></>;
    }

    const integration = getIntegrationQuery.data.integration;

    return (
        <Drawer drawerId={drawerId} title={<DrawerTitle mainTitle={t("title")} subTitles={[integration.name]} />}>
            <ModifyIntegrationMethodsForm onClose={() => drawerUtils.hide(drawerId)} integration={integration} />
        </Drawer>
    );
};
